import React, { useEffect, useState } from "react";
import { Row, Col, Button, Table } from 'react-bootstrap';
import styles from "./PartialOfferCard.module.css"
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { productListingType } from "../../utilities/settings";

export interface IPartialOffer {
    promotionHeaderId: number,
    promoName: string,
    promoDescription: string[],
    imageURL: string,
    startDate: string,
    endDate: string,
    isExternalLink: boolean,
    externalLink: string,
    eligibility: string[],
    newPrice: number,
    promotionDetails: any,
    onClickActionType: number,
    promotionCode: string
}
interface PropsType {
    productCard: IPartialOffer,
}


export default function PartialOfferCard(props: PropsType) {
    const dispatch = useDispatch();
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const responsive = useSelector((state: RootState) => state.responsive);

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])

    function explore() {

        if (props.productCard.isExternalLink) {
            window.open(props.productCard.externalLink, '_blank')
        }
        else if (props.productCard.promotionDetails) {
            if (props.productCard.promotionDetails.length == 1) {
                window.location.href = "/productDetails?ic=" + props.productCard.promotionDetails[0].itemCode + "&" + props.productCard.promotionDetails[0].itemName.replace(/ /g, "_").toUpperCase()
            }
            else if (props.productCard.promotionDetails.length > 1) {
                window.location.href = `/products/${productListingType.offer.toLowerCase()}/${props.productCard.promotionCode.toLowerCase()}`;
            }
            else { return }
        }
        else {
            window.location.href = `/products/${productListingType.offer.toLowerCase()}/${props.productCard.promotionCode.toLowerCase()}`;
        }
    }

    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <Row>
                    <Col lg="6" md="6" xs="12"  >
                        <img className={`${styles.imageTag}`} src={props.productCard.imageURL}
                            onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                    </Col>
                    <Col className={`${styles.detailContainer}`} style={{ marginLeft: isWeb ? "3rem" : "0" }}>
                        <div style={{ margin: isWeb ? "2rem 3rem 0 3rem" : "2rem 1rem 0 1rem" }}>
                            <Col md="12" className={`${styles.mainHeading}`}>
                                <span>{props.productCard.promoName}</span>
                            </Col>
                            <Table style={{ display: isWeb ? "flex" : "inline-table" }}>
                                <tbody>
                                    <tr className={`${styles.content}`} style={{ width: "100%" }}>
                                        <td>Valid </td>
                                        <td style={{ opacity: "0.5" }}>
                                            {props.productCard.startDate} - {props.productCard.endDate}
                                        </td>
                                        {/* <td className={`${styles.line}`}></td> */}
                                    </tr>
                                    <tr className={`${styles.content}`} style={{ marginBottom: "25px" }}>
                                        {props.productCard.eligibility != undefined && props.productCard.eligibility.length > 0 ?
                                            <>
                                                <td>Eligibility </td>
                                                <td>
                                                    {props.productCard.eligibility.map((item: string, index) => {
                                                        return (
                                                            <span key={index} style={{ opacity: "0.5" }}>
                                                                {item} <br />
                                                            </span>
                                                        )
                                                    })}
                                                </td>
                                                {/* <td className={`${styles.line}`}></td> */}
                                            </>
                                            : null
                                        }
                                    </tr>
                                </tbody>
                            </Table>
                            <Col md="12" sm="12" style={{ marginTop: "30px" }} className={`${styles.content}`}>
                                {
                                    props.productCard.promoDescription != undefined && props.productCard.promoDescription.length > 0 ?
                                        <>
                                            <td>
                                                {props.productCard.promoDescription.map((item: string, index) => {
                                                    return (
                                                        <span key={index}>
                                                            {item} <br />
                                                        </span>
                                                    )
                                                })}
                                            </td>
                                        </> : null
                                }
                            </Col>
                            <Button className="jkoa-blue-btn" style={{ marginBottom: "25px", marginLeft: "10px" }}
                                onClick={() => explore()}>
                                <div style={{ padding: "0", margin: "0" }}>View Products</div>
                            </Button>

                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}